import { Signal } from '@angular/core';
import { StoreService } from '../services/store.service';

export interface Pagination {
	totalRecords: number;
	currentPage: number;
	totalPages: number;
	nextPage: number | null;
	prevPage: number | null;
	loading: boolean;
	limit: number;
}

export const CURRENT_LIMIT = 10;

export class PaginationStore extends StoreService<Pagination> {
	constructor() {
		super();
		this.initializeState();
	}

	private initializeState(): void {
		this.setState({
			totalRecords: 0,
			currentPage: 0,
			totalPages: 0,
			nextPage: null,
			prevPage: null,
			loading: false,
			limit: CURRENT_LIMIT,
		});
	}

	public reset(): void {
		this.initializeState();
	}

	public getPages(): Signal<number> {
		return this.select('totalPages');
	}

	public getCurrentPage(): Signal<number> {
		return this.select('currentPage');
	}

	public getLoading(): Signal<boolean> {
		return this.select('loading');
	}

	public setLoading(loading: boolean): void {
		this.set('loading', loading);
	}

	public getLimit(): number {
		return this.select('limit')();
	}

	public getOffset(): number {
		return this.select('currentPage')() * this.select('limit')();
	}

	public setCurrentPage(page: number): void {
		this.set('currentPage', page);
	}

	public update(pagination: Partial<Pagination>): void {
		this.setState(pagination);
	}
}
